// このmixinはiOSのPWAで要素が描画されないことがあるので、mouted時に強制的にスクロールさせるmixinです。
// PWAでrouter.backすると戻ったページ先でスクロールするまで要素が表示されないことがあるので強制的にスクロールさせる
export default {
  mounted() {
    this.$nextTick(() => {
      window.scrollBy(0, 1)
      window.scrollBy(0, -1)
    })
  }
}